import { request } from '@umijs/max';
import { config } from '@/utils/config';
import {
  CommunityListType,
  RequestType,
  UploadRequestType,
  WechatSettingType,
  WechatUserInfoType,
} from '@/interface';
import qs from 'qs';

export const queryLogin = async (data?: any) => {
  return request('/LoginApi/api/oauth/Login', {
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Senke-Origin': 'pc',
      Authorization: '',
    },
  });
};

export const queryMock = () => {
  return request('/mockApi/api/tenant/DbName/wuye');
};

/**
 * @desc 获取微信配置信息
 */
export const queryWeChatSetting = async () => {
  return request<Promise<RequestType<WechatSettingType>>>(
    `/api/property/api/senke/Wxchat/getSettings/${config.companyCode}`,
    {
      method: 'get',
    },
  );
};
/**
 * @desc 创建微信账户
 * @param data
 */
export const queryCreateWechatAccount = async (data: WechatUserInfoType) => {
  return request('/api/property/api/senke/Wxchat/create/account', {
    method: 'POST',
    data,
  });
};

/**
 * @desc 查询小区
 */
export const queryWechatCommunity = async () => {
  return request<Promise<RequestType<CommunityListType[]>>>(
    '/api/property/api/senke/Wxchat/query/community',
  );
};

/**
 * @desc 绑定小区
 * @param data
 */
export const queryBindCommunity = async (data: {
  openId: string;
  communityId: string;
  isDefault: 0 | 1;
}) => {
  return request<Promise<RequestType<any>>>(
    '/api/property/api/senke/Wxchat/binding/community',
    {
      method: 'POST',
      data,
    },
  );
};

export const queryWechatAccountInfo = async (openId: string) => {
  return request<Promise<RequestType<WechatUserInfoType>>>(
    `/api/property/api/senke/Wxchat/query/account/${openId}`,
  );
};

/**
 * @desc 通用批量上传接口
 * @param data
 */
export const queryCommonUploads = async (data: any) =>
  request<Promise<UploadRequestType>>('/api/community/common/uploads', {
    method: 'POST',
    data,
  });
